import { handleActions } from 'redux-actions'

import {
  LOGIN_START,
  LOGIN_ERROR,
  LOGIN_FINALLY,
  LOGOUT,
  LOGIN_SET_AUTH,
  LOGIN_SET_PROFILE,
} from '../../actions'

const initialState = {
  loading: false,
  error: null,
  profile: null,
  email: '',
  password: '',
}

export default handleActions({
  [LOGIN_START]: state => ({
    ...state,
    loading: true,
    error: null,
  }),
  [LOGIN_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
  }),
  [LOGIN_FINALLY]: state => ({
    ...state,
    loading: false,
  }),
  [LOGIN_SET_AUTH]: (state, { payload: { key, value } }) => ({
    ...state,
    [key]: value,
  }),
  [LOGIN_SET_PROFILE]: (state, action) => ({
    ...state,
    profile: action.payload,
  }),
  [LOGOUT]: () => initialState,
}, initialState)
